import React from 'react';

interface Icon3DMobileProps {
  size?: string;
}

const Icon3DMobile: React.FC<Icon3DMobileProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-5/6 h-full rounded-lg bg-gradient-to-r from-pink-500 to-pink-600 shadow-xl relative"
        style={{
          animation: 'tilt 3s ease-in-out infinite',
          transformStyle: 'preserve-3d',
          boxShadow: '8px 8px 16px rgba(0,0,0,0.3), -2px -2px 8px rgba(255,255,255,0.1)'
        }}
      >
        <div className="absolute inset-1 bg-yellow-300 rounded-md" />
        <div className="absolute inset-2 bg-gradient-to-b from-pink-300 to-pink-600 rounded-sm" />
        <style>{`
          @keyframes tilt {
            0%, 100% { transform: rotateX(0deg) rotateY(-15deg) rotateZ(0deg); }
            50% { transform: rotateX(8deg) rotateY(15deg) rotateZ(2deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DMobile;
